import { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import {
    getAssessmentChallenge,
    getAssessmentChallengesFetchError,
    getAssessmentChallengesIsFetching,
} from '@selectors/assessmentChallenges';
import { fetchAssessmentChallenges } from '@actions/assessmentChallenges';

const useFetchAssessmentChallenge = (id?: number) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!!id) dispatch(fetchAssessmentChallenges());
    }, [dispatch, id]);

    const challenge = useSelector((state: RootState) => getAssessmentChallenge(state, id ?? -1));

    const assessmentChallenge =
        useSelector((state: RootState) => getAssessmentChallenge(state, id ?? -1)) || {};
    const isFetching = useSelector(getAssessmentChallengesIsFetching);
    const fetchError = useSelector(getAssessmentChallengesFetchError);

    return { challenge, assessmentChallenge, isFetching, fetchError };
};

export default useFetchAssessmentChallenge;
